import { createActions, createAction } from 'redux-actions';

export const resetJobsList = createAction('RESET_JOBS_LIST');
export const { loadJobs, loadedJobs, errorJobs } = createActions('LOAD_JOBS', 'LOADED_JOBS', 'ERROR_JOBS');
export const { toggleJobSelection, resetSelectedJobs } = createActions('TOGGLE_JOB_SELECTION', 'RESET_SELECTED_JOBS');
export const toggleAllJobsSelections = createAction('TOGGLE_ALL_JOBS_SELECTIONS');
export const resetJobsTable = createAction('RESET_JOBS_TABLE');
